import type { EmailVerificationResponse } from '@server/domains/users/controller/email-verification.handler'
import { rpc } from '@server/infrastructure/rpc'

import { getBearerToken } from '../../authentication'

export type { EmailVerificationResponse }

export type EmailVerificationStatus = EmailVerificationResponse['status']

export const requestEmailVerification = async (
  email: string,
  bearerToken?: string,
): Promise<EmailVerificationResponse> => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users['email-verifications'].$post(
    { json: { email } },
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to request email verification: ${response.status}`)
  }

  return response.json()
}

export const confirmEmailVerification = async (
  email: string,
  code: string,
  bearerToken?: string,
): Promise<EmailVerificationResponse> => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users['email-verifications'].confirmations.$post(
    { json: { email, code } },
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to confirm email verification: ${response.status}`)
  }

  return response.json()
}
